export default __webpack_public_path__ + "static/media/midna.fd7e8b5e.gif";